export default __webpack_public_path__ + "static/media/star-solid.4b010890.svg";